import { Tmkrandomstringhow } from '../../../shared/core-types/union.types';

/**
 * Generates a pseudo-random string with the requested length using the selected character set.
 *
 * @remarks
 * - This function is not cryptographically secure. Do not use it for tokens, passwords, or other secrets.
 * - For `letters` and `combined`, only lowercase ASCII letters are used.
 *
 * @param length - Desired length of the output string. Must be a non-negative integer.
 * @param how - Which character set to use:
 *   - `numbers` — digits 0–9
 *   - `letters` — lowercase a–z
 *   - `combined` — lowercase a–z and digits 0–9
 *
 * @returns A string of `length` characters drawn uniformly at random from the selected set.
 *
 * @example
 * // e.g. "k9b3q" (actual output varies)
 * const id = makeRandomString(5, 'combined');
 *
 * @example
 * // e.g. "07241"
 * const pin = makeRandomString(5, 'numbers');
 */
export const makeRandomString = (
  length: number,
  how: Tmkrandomstringhow
): string => {
  let outString = '';
  let inOptions;

  switch (how) {
    case 'numbers':
      inOptions = '0123456789';
      break;
    case 'letters':
      inOptions = 'abcdefghijklmnopqrstuvwxyz';
      break;
    case 'combined':
      inOptions = 'abcdefghijklmnopqrstuvwxyz0123456789';
      break;
  }

  for (let i = 0; i < length; i++) {
    outString += inOptions.charAt(Math.floor(Math.random() * inOptions.length));
  }

  return outString;
};
